import { render, staticRenderFns } from "./StatistiquesTableau.vue?vue&type=template&id=95771234&"
import script from "./StatistiquesTableau.vue?vue&type=script&lang=js&"
export * from "./StatistiquesTableau.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "StatistiquesTableau.vue"
export default component.exports